import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

interface usePublicationsProps {
  id: string;
  beat_id: string;
}

export function useDrafts({ id, beat_id }: usePublicationsProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { isLoading, refetch, error, data } = useQuery({
    queryKey: `influencer-collaboration-${id}-${beat_id}-drafts`,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/collaboration/${id}/drafts?beat_id=${beat_id}`,
        token
      }).then((response: { drafts: Api.Influencer.Draft[] } | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      })
    // enabled: !!token && enabled
  });

  return {
    drafts: (data?.drafts as Api.Influencer.Draft[]) || [],
    isLoading,
    refetch,
    error
  };
}
